// @ts-nocheck
import * as types from '../../mutation-types';
import actions from './actions';

const state = {
  loadingData: false,
};

const getters = {
  loadingData: (state) => state.loadingData,
};

const mutations = {
  [types.SET_LOADING](state, isLoading) {
    state.loadingData = isLoading;
  },
};

export default { state, getters, mutations, actions };
